import React, { useState } from "react";
import { motion } from "framer-motion";
import { TECHNOLOGIES_DATA } from "config/data";
import { Reveal } from "components/ui/motion";

const LABELS = {
  ai: "AI / ML",
  mobile: "Mobile",
  frontend: "Web & Backend",
  designing: "Design",
};

const TechnologiesStack = () => {
  const categories = Object.keys(TECHNOLOGIES_DATA);
  const [activeTab, setActiveTab] = useState(categories[0]);

  return (
    <section className="bg-slate-50 py-20">
      <div className="container-tt">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow !text-brand-600 justify-center w-full">
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
            Our stack
          </span>
          <h2 className="mt-4 text-3xl font-semibold text-ink sm:text-4xl">Technologies we build with</h2>
          <p className="mt-4 text-base text-slate-500">
            Modern, battle-tested tools — from large language models to native mobile frameworks.
          </p>
        </Reveal>

        {/* tabs */}
        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveTab(cat)}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition-all ${
                activeTab === cat
                  ? "bg-brand-gradient text-white shadow-glow"
                  : "border border-slate-200 bg-white text-slate-600 hover:border-brand-200"
              }`}
            >
              {LABELS[cat] || cat}
            </button>
          ))}
        </div>

        <motion.div
          key={activeTab}
          className="mx-auto mt-10 grid max-w-4xl grid-cols-3 gap-4 sm:grid-cols-4 lg:grid-cols-6"
          initial="hidden"
          animate="visible"
          variants={{ visible: { transition: { staggerChildren: 0.05 } } }}
        >
          {TECHNOLOGIES_DATA[activeTab].map(({ icon, title }) => (
            <motion.div
              key={title}
              variants={{ hidden: { opacity: 0, scale: 0.85, y: 12 }, visible: { opacity: 1, scale: 1, y: 0 } }}
              whileHover={{ y: -6 }}
              className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-slate-100 bg-white p-5 text-center shadow-card"
            >
              <span className="flex h-9 items-center text-4xl [&_img]:h-9">{icon}</span>
              <span className="text-xs font-medium leading-tight text-slate-600">{title}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechnologiesStack;
